<template>
    <div class="d-flex align-items-center justify-content-end gap-1 my-3">
        <base-button
            v-if="showDateDisplayButton"
            class="smaller-button"
            :type="displayType === 'date' ? 'primary' : 'light'"
            @click="$emit('select', 'date')">
            <font-awesome-icon
                icon="calendar"
                size="lg" />
        </base-button>
        <base-button
            v-if="showMapDisplayButton"
            class="smaller-button"
            :type="displayType === 'map' ? 'primary' : 'light'"
            @click="$emit('select', 'map')">
            <font-awesome-icon
                icon="map"
                size="lg" />
        </base-button>
        <base-button
            v-if="showCompactDisplayButton"
            class="smaller-button"
            :type="displayType === 'compact' ? 'primary' : 'light'"
            @click="$emit('select', 'compact')">
            <font-awesome-icon
                icon="list-ul"
                size="lg" />
        </base-button>
        <base-button
            v-if="showTileDisplayButton"
            class="smaller-button"
            :type="displayType === 'tile' ? 'primary' : 'light'"
            @click="$emit('select', 'tile')">
            <font-awesome-icon
                icon="grip"
                size="lg" />
        </base-button>
        <base-button
            v-if="showListDisplayButton"
            class="smaller-button"
            :type="displayType === 'list' ? 'primary' : 'light'"
            @click="$emit('select', 'list')">
            <font-awesome-icon
                icon="bars"
                size="lg" />
        </base-button>
    </div>
</template>

<script>
export default {
    name: "DisplaySelection",
    props: {
        displayType: {
            type: String,
            default: 'list'
        },
        availableDisplayTypes: {
            type: Array,
            default: () =>[]
        },
        iframeType: {
            type: String,
            default: 'events'
        }
    },
    computed: {
        showDateDisplayButton() {
            return this.availableDisplayTypes.includes('date') && this.iframeType === 'appointments'
        },
        showMapDisplayButton() {
            return this.availableDisplayTypes.includes('map') && this.iframeType === 'events'
        },
        showTileDisplayButton() {
            return this.availableDisplayTypes.includes('tile')
        },
        showListDisplayButton() {
            return this.availableDisplayTypes.includes('list')
        },
        showCompactDisplayButton() {
            return this.availableDisplayTypes.includes('compact')
        },
    }
}
</script>

<style scoped>

</style>